import React, { useState, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import Loading from '../components/Loading';
import ErrorToast from '../components/ErrorToast';
import Paginacao from '../components/Paginacao';
import '../styles/Common.css';

const EventosClientePage = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);
  const [total, setTotal] = useState(0);
  const [filtros, setFiltros] = useState({
    tipo_evento: '',
    usuario_cadastro: '',
    cliente_id: '',
  });

  const fetchEventos = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await api.get('/eventos-cliente', {
        params: { ...filtros, page, pageSize },
      });
      setEventos(response.data.data);
      setTotal(response.data.total);
    } catch (err) {
      setError('Erro ao buscar eventos do cliente.');
    } finally {
      setLoading(false);
    }
  }, [filtros, page, pageSize]);

  useEffect(() => {
    fetchEventos();
  }, [fetchEventos]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchEventos();
  };

  return (
    <div className="page-container">
      <h1 className="page-title">Eventos do Cliente</h1>

      <div className="filters-section">
        <form onSubmit={handleSearch}>
          <div className="filters-grid">
            <div className="filter-item">
              <label>Tipo do Evento:</label>
              <input
                type="text"
                name="tipo_evento"
                value={filtros.tipo_evento}
                onChange={handleInputChange}
                placeholder="Ex: EMAIL_ENVIADO"
              />
            </div>
            
            <div className="filter-item">
              <label>Usuário:</label>
              <input
                type="text"
                name="usuario_cadastro"
                value={filtros.usuario_cadastro}
                onChange={handleInputChange}
                placeholder="Ex: N8N"
              />
            </div>
            <div className="filter-item">
              <label>Cliente ID:</label>
              <input
                type="text"
                name="cliente_id"
                value={filtros.cliente_id}
                onChange={handleInputChange}
                placeholder="Ex: 123"
              />
            </div>
          </div>
          <div className="filter-actions">
            <button type="submit" className="button">
              Buscar
            </button>
          </div>
        </form>
      </div>

      {loading && <Loading />}
      {error && <ErrorToast message={error} onClose={() => setError('')} />}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Tipo do Evento</th>
              <th>Detalhe</th>
              <th>Data</th>
              <th>Usuário</th>
              <th>Cliente</th>
            </tr>
          </thead>
          <tbody>
            {eventos.map((evento) => (
              <tr key={evento.id}>
                <td>{evento.tipo_evento}</td>
                <td>{evento.detalhe_evento}</td>
                <td>{new Date(evento.data_evento).toLocaleString()}</td>
                <td>{evento.usuario_cadastro}</td>
                <td><Link to={`/clientes/${evento.cliente_id}`}>{evento.cliente_id}</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Paginacao
        totalItens={total}
        itensPorPagina={pageSize}
        paginaAtual={page}
        setPaginaAtual={setPage}
      />
    </div>
  );
};

export default EventosClientePage;